export const TransactionFilters = {
  ACCOUNT_NUMBER: {
    value: 'ACCOUNT_NUMBER',
    name: 'transactions.filter.accountNumber',
  },
  ACTIONS_INVOICE_REF: {
    value: 'ACTIONS_INVOICE_REF',
    name: 'transactions.filter.invoiceRef',
  },
  CARD_NUMBER: {
    value: 'CARD_NUMBER',
    name: 'transactions.filter.cardNumber',
  },
  CUSTOMER_EMAIL: {
    value: 'CUSTOMER_EMAIL',
    name: 'transactions.filter.customerEmail',
  },
  CUSTOMER_FULL_NAME: {
    value: 'CUSTOMER_FULL_NAME',
    name: 'transactions.filter.customerFullName',
  },
  CUSTOMER_GOVERNMENT_ID: {
    value: 'CUSTOMER_GOVERNMENT_ID',
    name: 'transactions.filter.customerGovernmentId',
  },
  CUSTOMER_MOBILE_PHONE: {
    value: 'CUSTOMER_MOBILE_PHONE',
    name: 'transactions.filter.customerMobilePhoneNumber',
  },
  EXTERNAL_ID: {
    value: 'EXTERNAL_ID',
    name: 'transactions.filter.externalId',
  },
  MIN_AMOUNT: {
    value: 'MIN_AMOUNT',
    name: 'transactions.filter.minAmount',
  },
  MAX_AMOUNT: {
    value: 'MAX_AMOUNT',
    name: 'transactions.filter.maxAmount',
  },
  SHOW_ONLY_ONGOING_OR_DELAYED_PAYMENTS: {
    value: 'SHOW_ONLY_ONGOING_OR_DELAYED_PAYMENTS',
  },
  STATUS: {
    value: 'STATUS',
    values: ['ANNULLED', 'FROZEN', 'APPROVED'],
    valueTranslations: {
      ANNULLED: 'transactions.annulled',
      FROZEN: 'transactions.frozen',
      APPROVED: 'transactions.approved',
    },
    name: 'transactions.filter.status',
  },
  PAYMENT_STATUS: {
    value: 'PAYMENT_STATUS',
    values: ['debited', 'credited', 'annulled', 'debitable', 'creditable'],
    valueTranslations: {
      debited: 'transactions.debited',
      credited: 'transactions.credited',
      annulled: 'transactions.annulled',
      debitable: 'transactions.debitable',
      creditable: 'transactions.creditable',
    },
    name: 'transactions.filter.paymentStatus',
  },
  CHANNEL_TYPE: {
    value: 'CHANNEL_TYPE',
    name: 'transactions.filter.channelType',
  },
  STORE_STORE_ID: {
    value: 'STORE_STORE_ID',
    name: 'login.storeId',
  },
}
